export default __webpack_public_path__ + "static/gallucci-editore-7a5588eb25cbb896a68710ae003fa665.png";